import { render, staticRenderFns } from "./PromotionTag.vue?vue&type=template&id=e992f690&"
import script from "./PromotionTag.vue?vue&type=script&lang=js&"
export * from "./PromotionTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports